// extracted by mini-css-extract-plugin
export var questions = "faq-module--questions--0b69f";
export var questions__title = "faq-module--questions__title--4a431";
export var questions_col = "faq-module--questions_col--2fd3f";
export var questions_col_item = "faq-module--questions_col_item--4b895";
export var questions_col_item_header = "faq-module--questions_col_item_header--a61f0";
export var questions_col_item_name = "faq-module--questions_col_item_name--8b46c";
export var questions_row = "faq-module--questions_row--965dc";